export default "__VITE_ASSET__DJAWrGS8__"